import type { Task } from './Task';
import type { ServiceArea } from './ForemanArea';

export interface Activity {
  id: number;
  activityName: string;
  activityNumber: string;
  unitOfMeasure: string;
  scheduled2Rate?: number | null;
  serviceAreaId?: number | null;
  contractYear?: number | null;
  point?: boolean;
  linear?: boolean;
  activityProfile?: string;
  activityType?: string;
  locationCode?: string;
  classification?: string;
  threshold?: number | null;
  serviceArea?: ServiceArea | null;
  tasks?: Task[];
  activityCostings?: Array<{
    id: number;
    serviceAreaId: number;
    contractYear: number | null;
    scheduled2Rate: number | null;
    serviceArea?: ServiceArea | null;
  }>;
} 

export enum ActivityType {
  Routine = 'Routine',
  Overhead = 'Overhead',
  Quantified = 'Quantified',
}